import { useEffect, useState } from "react";
import { addExpense } from "./TransactionService";
import { getAllAccounts } from "../accounts/AccountService";
import { getAllCategories } from "../categories/CategoryService";
import { getAllMerchants } from "../merchants/MerchantService";
import { getAllTags } from "../tags/TagService";

export default function ExpenseForm(){

  const [accounts,setAccounts]=useState([]);
  const [categories,setCategories]=useState([]);
  const [merchants,setMerchants]=useState([]);
  const [tags,setTags]=useState([]);

  const [form,setForm]=useState({
    accountId:"",
    categoryId:"",
    merchantId:"",
    amount:"",
    date:"",
    description:"",
    tags:[]
  });

  useEffect(()=>{
    load();
  },[]);

  const load = async ()=>{
    setAccounts(await getAllAccounts());
    setCategories(await getAllCategories());
    setMerchants(await getAllMerchants());
    setTags(await getAllTags());
  };

  const submit = async (e)=>{
    e.preventDefault();
    await addExpense(form);
    alert("Expense added");
  };

  const toggleTag = (id)=>{
    setForm(f=>({
      ...f,
      tags: f.tags.includes(id) ? f.tags.filter(t=>t!==id) : [...f.tags,id]
    }));
  };

  return (
    <form onSubmit={submit}>
      <div className="card">
  <div className="card-title">Add Expense</div>

  <div className="form-grid">

    <select className="input" onChange={e=>setForm({...form,accountId:e.target.value})}>
      <option value="">Select Account</option>
      {accounts.map(a=><option key={a.id} value={a.id}>{a.accountName}</option>)}
    </select>

    <select className="input" onChange={e=>setForm({...form,categoryId:e.target.value})}>
      <option value="">Select Category</option>
      {categories.map(c=><option key={c.id} value={c.id}>{c.categoryName}</option>)}
    </select>

    <select className="input" onChange={e=>setForm({...form,merchantId:e.target.value})}>
      <option value="">Select Merchant</option>
      {merchants.map(m=><option key={m.id} value={m.id}>{m.merchantName}</option>)}
    </select>

    <input className="input" type="number" placeholder="Amount"
      onChange={e=>setForm({...form,amount:e.target.value})} />

    <input className="input" type="date"
      onChange={e=>setForm({...form,date:e.target.value})} />

    <textarea className="input form-full" placeholder="Description"
      onChange={e=>setForm({...form,description:e.target.value})} />

  </div>

  {/* Tags */}
  <div style={{ marginTop:"15px", display:"flex", flexWrap:"wrap", gap:"10px" }}>
    {tags.map(t=>(
      <label key={t.id} style={{ background:"#f1f5f9", padding:"6px 10px", borderRadius:"6px" }}>
        <input type="checkbox" onChange={()=>toggleTag(t.id)} /> {t.tagName}
      </label>
    ))}
  </div>

  <div style={{ marginTop:"20px", textAlign:"right" }}>
    <button className="btn btn-primary">Save Expense</button>
  </div>
</div>

    </form>
  );
}
